import { getUserEvents } from '@/api/events'
import { ensureCurrentUser } from '@/services/auth'
import { initRequestHelper, isAlreadyPending } from '@/store/root'
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { EventsState } from '../types/event'
import { RootState } from '../types/root'

const getDefaultState = (): EventsState => {
  return {
    usage: null,
  }
}

const moduleState = getDefaultState()

const moduleGetters: GetterTree<EventsState, RootState> = {
  usage(state) {
    return state.usage
  },
  getEventsRequest(_state, _getters, rootState) {
    return rootState.requests.getEvents
  },
  isEventRequestPending(_state, getters) {
    return isAlreadyPending(getters.getEventsRequest)
  },
}

const moduleMutations: MutationTree<EventsState> = {
  setUsage(state, events) {
    state.usage = events
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

const moduleActions: ActionTree<EventsState, RootState> = {
  async getUsage({ commit, getters }, { userId, range }) {
    if (getters.isEventRequestPending) return
    const [setSuccess, setFailure] = initRequestHelper(commit, 'getEvents')
    try {
      if (!userId) {
        const currentUser = ensureCurrentUser()
        userId = currentUser.uid
      }
      const rows = await getUserEvents(userId, range)
      commit('setUsage', rows)
      setSuccess()
    } catch (err: any) {
      setFailure(err.message)
      throw err
    }
  },
  async resetEventsState({ commit }) {
    commit('resetState')
  },
}

const events: Module<EventsState, RootState> = {
  namespaced: true,
  state: moduleState,
  getters: moduleGetters,
  actions: moduleActions,
  mutations: moduleMutations,
}
export default events
